import _ from "underscore";
import CustomStore from 'devextreme/data/custom_store';
import { getEventGroups } from "@/services/api";

export const eventGroupDataSourceConfig = {
  store: new CustomStore({
    key: 'id',
    load: async function() {
      const data = await getEventGroups();
      data.forEach(rec => _.extend(rec, { value: rec.id, text: rec.name }));
      return { data, totalCount: data.length };
    },
    byKey: async function(id) {
      const data = await getEventGroups();
      data.forEach(rec => _.extend(rec, { value: rec.id, text: rec.name }));
      return data.filter(rec => rec.id === id)[0];
    }
  })
};
